import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { useCollection } from 'Context/CollectionContext';
import DataContainer from 'Components/UI/DataContainer';
import { TrustApprovalOverride } from 'Resources/TrustApproval';

const styles = theme => ({
  root: {},
  header: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    fontWeight: theme.typography.fontWeightBold,
  },
  uploadSection: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(4, 0),
  },
  sendButton: {
    borderRadius: theme.radius.sm,
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    minWidth: theme.dimensions.sm,
  },
});

const TrustForm = ({
  classes,
  onSubmit,
}) => {
  const { collection, isInitializing, initializingError } = useCollection();
  const resource = collection?.resources().length() > 0 ? collection.resources().head() : collection?.create();

  return (
    <DataContainer loading={isInitializing || !collection} loadingError={initializingError}>
      <Box className={classes.root} p={2}>
        {resource !== null && <MetaFormInline resource={resource} onSubmit={onSubmit} metaOverrideSet={TrustApprovalOverride} />}
      </Box>
    </DataContainer>
  );
};

TrustForm.defaultProps = {};

TrustForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TrustForm);
